import React from 'react';
import { StarIcon } from 'lucide-react';
import { REVIEWS } from '../data/content';
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-151">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} size={16} className="fill-yellow-400 text-yellow-400" data-id="element-152" />)}
    </div>;
}
export function Reviews() {
  return <section className="px-5 py-8" data-id="element-153">
      <div className="mx-auto max-w-xl space-y-4" data-id="element-154">
        {REVIEWS.map(r => <figure key={r.name} className="rounded-2xl border border-white/20 bg-[#101b2d]/95 p-5 shadow-lg shadow-black/20" data-id="element-155">
            <div className="flex items-center justify-between" data-id="element-156">
              <Stars data-id="element-157" />
              <span className="rounded-full border border-[var(--pb-lime)]/25 bg-[var(--pb-lime)]/15 px-2 py-0.5 text-[10px] font-700 uppercase tracking-wide text-[var(--pb-lime)]" data-id="element-158">
                Verified
              </span>
            </div>
            <blockquote className="mt-3 text-sm leading-relaxed text-white/95" data-id="element-159">
              “{r.text}”
            </blockquote>
            <figcaption className="mt-3 text-sm font-700 text-white" data-id="element-160">
              {r.name}{' '}
              <span className="font-500 text-white/50" data-id="element-161">· {r.city}</span>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}